module.exports = __webpack_public_path__ + "img/Group 14.40c42987.svg";